/*
 * Reactivate Twente — Debug logger
 *
 * Standaard staat debug AAN in de theme editor en UIT in productie.
 *
 * In de browser-console kan je het overschrijven:
 *   localStorage.setItem('rt-debug', 'true')  // aanzetten
 *   localStorage.setItem('rt-debug', 'false') // uitzetten
 *   localStorage.removeItem('rt-debug')        // terug naar default (auto)
 *
 * Snelle commando's in de console:
 *   RT.info()      // overzicht van alle gerenderde rt-* secties + settings
 *   RT.sections()  // lijst section-namen + hun ID's
 *   RT.errors()    // alle JS-errors die zijn opgevangen
 *   RT.help()      // alle commando's
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'rt-debug';
  const PREFIX = 'background:#10253a;color:#f3efe9;padding:2px 8px;border-radius:3px;font-weight:700;';
  const PREFIX_WARN = 'background:#a88a56;color:#10253a;padding:2px 8px;border-radius:3px;font-weight:700;';
  const PREFIX_ERR = 'background:#7f1718;color:#f3efe9;padding:2px 8px;border-radius:3px;font-weight:700;';
  const PREFIX_OK = 'background:#375d4a;color:#f3efe9;padding:2px 8px;border-radius:3px;font-weight:700;';

  function isEnabled() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'true') return true;
    if (stored === 'false') return false;
    // Default: aan in design mode (theme editor)
    return !!(window.Shopify && window.Shopify.designMode);
  }

  const sections = [];
  const errors = [];
  let enabled = isEnabled();

  function ts() {
    const d = new Date();
    return d.toTimeString().slice(0, 8) + '.' + String(d.getMilliseconds()).padStart(3, '0');
  }

  const RT = window.RT = window.RT || {};

  RT.enable = function () {
    localStorage.setItem(STORAGE_KEY, 'true');
    enabled = true;
    console.log('%cRT%c debug AAN', PREFIX_OK, 'color:#375d4a');
  };

  RT.disable = function () {
    localStorage.setItem(STORAGE_KEY, 'false');
    enabled = false;
    console.log('%cRT%c debug UIT', PREFIX, 'color:#10253a');
  };

  RT.toggle = function () {
    enabled ? RT.disable() : RT.enable();
  };

  RT.log = function (label, data) {
    if (!enabled) return;
    if (data !== undefined) {
      console.log('%cRT%c ' + ts() + ' ' + label, PREFIX, 'color:#10253a', data);
    } else {
      console.log('%cRT%c ' + ts() + ' ' + label, PREFIX, 'color:#10253a');
    }
  };

  RT.warn = function (label, data) {
    if (!enabled) return;
    if (data !== undefined) {
      console.warn('%cRT%c ' + label, PREFIX_WARN, 'color:#a88a56', data);
    } else {
      console.warn('%cRT%c ' + label, PREFIX_WARN, 'color:#a88a56');
    }
  };

  RT.error = function (label, data) {
    // Errors loggen altijd, ook als debug uitstaat
    if (data !== undefined) {
      console.error('%cRT%c ' + label, PREFIX_ERR, 'color:#7f1718', data);
    } else {
      console.error('%cRT%c ' + label, PREFIX_ERR, 'color:#7f1718');
    }
    errors.push({ time: ts(), label: label, data: data });
  };

  RT.section = function (info) {
    sections.push(info);
    if (!enabled) return;
    console.groupCollapsed('%cRT%c ' + info.type + ' #' + info.id, PREFIX, 'color:#10253a');
    console.log('settings:', info.settings || {});
    if (info.blocks && info.blocks.length) {
      console.log('blocks (' + info.blocks.length + '):', info.blocks);
    }
    if (info.notes && info.notes.length) {
      info.notes.forEach(function (n) { console.log('· ' + n); });
    }
    console.groupEnd();
  };

  RT.info = function () {
    console.group('%cRT%c ' + sections.length + ' secties gerenderd op deze pagina', PREFIX_OK, 'color:#375d4a;font-weight:600');
    sections.forEach(function (s) {
      console.groupCollapsed(s.type + ' #' + s.id);
      console.log('settings:', s.settings || {});
      if (s.blocks) console.log('blocks:', s.blocks);
      console.groupEnd();
    });
    console.groupEnd();
    return sections;
  };

  RT.sections = function () {
    const list = sections.map(function (s) { return s.type + ' #' + s.id; });
    console.table(list);
    return list;
  };

  RT.errors = function () {
    if (errors.length === 0) {
      console.log('%cRT%c geen errors opgevangen', PREFIX_OK, 'color:#375d4a');
      return [];
    }
    console.group('%cRT%c ' + errors.length + ' errors', PREFIX_ERR, 'color:#7f1718;font-weight:600');
    errors.forEach(function (e) {
      console.error(e.time + ' — ' + e.label, e.data);
    });
    console.groupEnd();
    return errors;
  };

  RT.clear = function () {
    sections.length = 0;
    errors.length = 0;
    console.clear();
    console.log('%cRT%c logs cleared', PREFIX, 'color:#10253a');
  };

  RT.help = function () {
    console.group('%cRT%c debug commands', PREFIX_OK, 'color:#375d4a;font-weight:600');
    console.log('RT.enable()    — debug logging aanzetten en opslaan');
    console.log('RT.disable()   — debug logging uitzetten');
    console.log('RT.toggle()    — schakelen');
    console.log('RT.info()      — overzicht van alle secties op deze pagina');
    console.log('RT.sections()  — table met alle section-namen');
    console.log('RT.errors()    — alle opgevangen JS-errors');
    console.log('RT.clear()     — console + logs leegmaken');
    console.log('');
    console.log('Status: debug ' + (enabled ? 'AAN' : 'UIT'));
    console.log('Design mode: ' + (window.Shopify && window.Shopify.designMode ? 'JA' : 'nee'));
    console.groupEnd();
  };

  // Vang ongerelateerde JS errors op
  window.addEventListener('error', function (e) {
    if (!e || !e.message) return;
    RT.error('JS error: ' + e.message, {
      filename: e.filename,
      line: e.lineno,
      column: e.colno,
      stack: e.error && e.error.stack
    });
  });

  window.addEventListener('unhandledrejection', function (e) {
    RT.error('Promise rejection', e.reason);
  });

  // Banner bij eerste keer laden
  if (enabled) {
    console.log(
      '%cRT%c debug AAN. Type %cRT.help()%c voor alle commands.',
      PREFIX_OK,
      'color:#375d4a',
      'background:#f3efe9;color:#10253a;padding:1px 6px;border-radius:3px;font-family:monospace;',
      'color:#10253a'
    );
  }
})();
